import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  page: 1,
  limit: 10,
  search_params: {
    prefecture_id: null,
    medical_institution_name: null,
    word: null
  }
}

export const partnersPaginationSlice = createSlice({
  name: 'partnersPagination',
  initialState,
  reducers: {
    setPage: (state, action) => {
      return {
        ...state,
        page: action.payload,
      }
    },
    setParams: (state, action) => {
      return {
        ...state,
        search_params: action.payload
      }
    }
  },
})

export const { setPage, setParams } = partnersPaginationSlice.actions

export default partnersPaginationSlice.reducer